export default __webpack_public_path__ + "assets/Beachfront.fe5bbfe0.webp";